import { shutdownIntercom } from '../../analytics/adapters/intercomAdapter';
import cacheService from '../../../services/cacheService';
import { shutdownEventStream } from '../../event-stream';
import { clearSessionUserCache } from '../api/getSessionUser';
import { clearStoredUser } from './userStorage';

function clearAuthStorageKeys(): void {
  try {
    window.localStorage.removeItem('redirectEmail');
    window.localStorage.removeItem('receivedEvents');
  } catch {
    /* ignore */
  }
}

export function clearSessionForImpersonation(): void {
  cacheService.removeAll();
  shutdownEventStream();
  shutdownIntercom();

  clearStoredUser();
  clearAuthStorageKeys();
  clearSessionUserCache();
}
